import { render } from "./UserFormPage.vue?vue&type=template&id=172147e6&ts=true"
import script from "./UserFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user/UserFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "172147e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('172147e6', __exports__)) {
    api.reload('172147e6', __exports__)
  }
  
  module.hot.accept("./UserFormPage.vue?vue&type=template&id=172147e6&ts=true", () => {
    api.rerender('172147e6', render)
  })

}


export default __exports__